import React, { Component } from 'react';
import { Dialog, Checkbox } from '@tencent/spaui';
import { readAgreement } from '@/api/operator/cgi/smb/common/index.js'
;
class Agreement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: false,
      color: '#000',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.FooterLeftComponent = this.FooterLeftComponent.bind(this);
    this.onClose = this.onClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.computeShowList();
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.account.featureFlagInitDone && this.props.account.featureFlagInitDone) {
      this.computeShowList();
    }
  }
  computeShowList = () => {
    const { feature_flag_list = {}, agency_list = [] } = this.props.account;
    const arr = Object.keys(feature_flag_list);
    const featureFlagList = arr.filter((x) => {
      return feature_flag_list[x].is_user_agreement_enable;
    });
    let show;
    for (let i = 0, len = agency_list.length; i < len; i++) {
      if (featureFlagList.indexOf(String(agency_list[i].agency_uid)) >= 0) {
        show = true;
        break;
      }
    }
    this.setState({
      show,
      featureFlagList,
    });
  }
  handleChange(event, value) {
    if (value) {
      this.setState({});
    }
    this.setState({
      value,
      color: value ? '#000' : 'red',
    });
  }
  FooterLeftComponent() {
    const { value, color } = this.state;
    return (
      <Checkbox value={true} checked={value} onChange={this.handleChange}>
        <span style={{ color }}>同意以上规范协议</span>
      </Checkbox>
    );
  }

  handleSubmit() {
    const { value, featureFlagList } = this.state;
    if (!value) {
      this.setState({
        color: 'red',
      });
      return;
    }
    readAgreement({ data: { agency_uid_list: featureFlagList } }).then((res) => {
      if (res.code == 0) {
        this.onClose();
      }
    });
  }
  onClose() {
    this.setState({
      show: false,
    });
  }
  render() {
    const { value, show = false, inputValue } = this.state;
    return (
      <div>
        <Dialog show={show} onClose={this.onClose} onSubmit={this.handleSubmit} onCancel={this.onClose} title="腾讯广告-服务商合作协议" type="normal" closeButton={false} cancelButton={false} style={{ width: '800px' }} backdrop={true} FooterLeftComponent={this.FooterLeftComponent}>
          <div style={{ height: '300px', overflow: 'auto' }}>
            <div style={{ fontFamily: '宋体', padding: '0 20px' }}>
              <div style={{ fontSize: '15px', color: 'black', fontWeight: 'bold', padding: '20px 0', textAlign: 'center' }}>腾讯广告-服务商合作协议</div>
              <div style={{ textIndent: '2em' }}>欢迎您使用腾讯广告服务平台及相关服务！</div>
              <div style={{ textIndent: '2em' }}>
                您是合法注册、依法经营的主体，希望申请成为腾讯依法运营的腾讯广告服务平台的 服务商，推广腾讯广告服务。为使用腾讯广告服务平台及相关服务，
                <span style={{ color: 'black', fontWeight: 'bold' }}>
                  您应当阅读并遵守《腾讯广告-服务商合作协议》（以下简称:本协议）、《腾讯服务协议》等相关协议、规则。请您务必审慎阅读、充分理解各条款内容，特别是限制或免除责任的条款，以及开通或使用某项服务的单独协议、规则。限制或免责条款可能以加粗或加下划线的形式提示您重点注意。
                </span>
              </div>

              <div style={{ textIndent: '2em', color: 'black', fontWeight: 'bold' }}>
                除非您已阅读并接受本协议及相关协议、规则等的所有条款，否则，您无权使用本服 务。一旦您选择“同意”或“下一步”（具体措辞以服务开通时显示的为准）并完成注册 流程，或您以任何方式使用本服务，即视为您已阅读并同意上述协议、规则等的约束。
              </div>

              <div style={{ textIndent: '2em', color: 'black', fontWeight: 'bold' }}>您有违反本协议的任何行为时，腾讯有权依照您违反情况随时单方采取限制、中止或 终止向您提供服务等措施，并有权追究您相关责任。</div>

              <div style={{ textIndent: '2em' }}>在本协议中，您可称为“甲方”，腾讯可称为“乙方”。</div>

              <div style={{ fontWeight: 'bold' }}>一、定义</div>

              <div style={{ textIndent: '2em' }}>除非另有明确约定，否则，下列词语在本协议中具有如下含义:</div>

              <div style={{ textIndent: '2em' }}>
                1.1 腾讯广告服务平台：指由乙方或乙方关联公司、乙方合作伙伴自主研发并运营的 广告平台（包括广点通系统、微信公众平台广告服务系统、品牌排期广告系统等，具体以 腾讯广告服务平台实际提供为准，简称“腾讯平台”），可提供流量采购、营销推广、费
                用统计、数据查询、素材管理等腾讯广告服务。广告主/服务商可以按照腾讯平台规则，通 过腾讯平台的广点通系统、腾讯联盟广告、朋友圈广告、公众号广告、腾讯视频广告、腾 讯新闻广告、腾讯网广告等渠道将其广告展示在不同的媒体中。乙方通过腾讯广告服务平 台提供的服务统称“腾讯广告服务”。
              </div>

              <div style={{ textIndent: '2em' }}>1.2 服务商：指经乙方审核同意，有权依法向广告主推广腾讯广告服务的法人或其他 组织。服务商根据其选择的腾讯广告服务的具体类型，注册相应的腾讯平台账户，简称 “服务商账户”，或者直接同乙方签署单独的广告执行单进行广告投放业务申请并执行。</div>

              <div style={{ textIndent: '2em' }}>1.3 广告主：是指通过腾讯广告服务平台向用户宣传、推广产品、服务的主体，包括 子客广告主和直客广告主。</div>

              <div style={{ textIndent: '2em' }}>1.4 子客广告主：指由服务商引入的，使用腾讯广告服务的广告主，简称为“子 客”。</div>
              <div style={{ textIndent: '2em' }}>1.5 流量主：指为展示广告提供相关页面、位置的网站、游戏、应用、软件等媒体（如 QQ、微信、腾讯视频、腾讯新闻以及其他 APP 等）的运营者，包括但不限于乙方关联公 司、乙方合作伙伴等其他主体。</div>
              <div style={{ textIndent: '2em' }}>1.6 媒体：指由流量主运营的，为广告提供展示页面、位置的网站、游戏、应用等， 包括但不限于腾讯网、QQ、QQ 空间、微信、腾讯视频、腾讯新闻等乙方或乙方关联公司运 营的产品以及其他乙方合作伙伴运营的网站、游戏、应用等产品。</div>
              <div style={{ textIndent: '2em' }}>1.7 广告：指广告主自行设计制作或依法委托他人设计制作的，用于宣传其品牌或其 生产或销售的商品、服务的信息内容，包括但不限于图片、文字、视频、flash 等，广告 包括广告素材和落地页。</div>
              <div style={{ textIndent: '2em' }}>1.8 落地页：指广告所指向的内容，即用户点击广告后跳转到的首个页面。</div>
              <div style={{ textIndent: '2em' }}>1.9 推广对象：指广告直接或间接推广的产品、服务等，包括但不限于广告指向的微 信公众号、网页等。</div>
              <div style={{ textIndent: '2em' }}>1.10 广告费：指使用腾讯广告服务所产生的费用，广告费的结算方式包括但不限于 CPC(点击计费)、CPT(时长计费)和 CPM(千次广告展示计费)等，具体以腾讯平台规则为 准。</div>
              <div style={{ textIndent: '2em' }}>
                1.11 腾讯平台规则：指服务商、广告主使用腾讯平台时需要遵守的相关规则，包括但 不限于行业准入规则、广告审核规范、违规处罚规范、程序化交易管理规范、返货/返点政 策、服务商管理规范等规则及将来可能发布的与腾讯广告服务相关的协议、规则、规范 等。相关内容可能以网站公告、书面文件、通知、FAQ
                等多种形式体现，服务商、广告主 应当予以遵守。
              </div>
              <div style={{ textIndent: '2em' }}>1.12 服务商管理规范：指与规范服务商服务、市场推广、服务使用等行为相关的协 议、规则及将来可能发布的与服务商相关的协议、规则、规范等，统称为“服务商管理规 范”。相关内容可能以书面文件、通知、FAQ等多种形式体现，服务商应当予以遵守。</div>
              <div style={{ textIndent: '2em' }}>1.13 法律法规：指中华人民共和国（包括港澳台地区）、服务商/广告主所在地及广 告实际投放的国家、地区的相关法律、法规、部门规章及行业规范等。</div>
              <div style={{ fontWeight: 'bold' }}>二、服务规则</div>
              <div style={{ textIndent: '2em' }}>2.1 甲方应当依法合理推广腾讯广告服务，包括但不限于遵守以下规则：</div>
              <div style={{ textIndent: '2.5em' }}>（1）按照诚实信用和互惠互利的原则，安排专人负责腾讯广告服务业务，依法通过市 场活动、广告宣传等各种正面、积极的方式开拓市场，维护乙方的企业形象和品牌形象。 以优质的客户服务吸引子客，不得以低价、返货等方式实施不正当竞争的行为。</div>
              <div style={{ textIndent: '2.5em' }}>（2）以腾讯广告服务商身份拓展子客，但不得直接或间接以乙方或乙方关联公司名义 拓展子客，也不得以任何方式使子客误以为甲方是代表乙方或乙方关联公司与其接洽，双 方另有约定的除外。</div>
              <div style={{ textIndent: '2.5em' }}>
                （3）不得通过任何不正当方式招揽子客，包括但不限于以直接抄袭、仿冒、伪造腾讯 广告服务平台官网（包括但不限于投放端系统等）等方式，使第三方误以为甲方运营的网 站是腾讯广告服务官网，或使第三方对甲方的网站或系统与腾讯广告服务官方网站、系统 产生混淆等。
              </div>
              <div style={{ textIndent: '2.5em' }}>（4）不得利用技术或其他手段破坏、扰乱腾讯平台的运营或妨碍他人对腾讯平台的使 用，或者制作、传播实施前述目的的方法等，也不得仿冒或使用仿冒的腾讯平台产品（包 括但不限于仿冒腾讯广告服务形式），使用户发生误解或混淆。</div>
              <div style={{ textIndent: '2em' }}>2.2 甲方应取得子客的合法授权，并应依照腾讯平台规则提供真实、合法、有效的甲 方及广告主相关证明文件（文件均需加盖当事人的公章或签字），包括但不限于：</div>
              <div style={{ textIndent: '2.5em' }}>（1）营业执照等身份证明以及其他生产、经营资质的证明文件等。</div>
              <div style={{ textIndent: '2.5em' }}>（2）完整、合法、有效的联系方式，如邮箱、电话、地址等。</div>
              <div style={{ textIndent: '2.5em' }}>（3）其他必要证明文件，包括但不限于产品质量检验证明、授权文件、广告审查表 等。</div>
              <div style={{ textIndent: '2em' }}>若上述证明文件发生变更的，甲方应当在变更之日起 3 个工作日内书面通知乙方或依 照腾讯平台规则进行修改。</div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>
                  2.3 腾讯平台规则可根据平台的运营安排或法律法规要求等随时单方进行调整，包括 但不限于根据流量主运营策略制定和调整主体准入类型（比如自然人、法人等）、广告设 计标准、广告审核规范、行业准入类别、资质审核范围、返货/返点政策、服务商管理规
                  范，以及对特定行业、情况收取或免除一定金额或比例的保证金等。甲方理解并同意： （1）乙方有权自行或通过腾讯平台以短信、即时通讯信息（如 QQ、微信等）、电
                </u>
              </div>
              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（1）乙方有权自行或通过腾讯平台以短信、即时通讯信息（如 QQ、微信等）、电子 邮件、自助系统、站内消息、网站公告等方式中的一种或多种，向甲方通知腾讯平台规 则。甲方应当及时查看相关内容。</u>
              </div>
              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>（2）经调整的腾讯平台规则自通知规定的生效日起生效，甲方应当遵守。腾讯平台 规则调整后，可能引起准入标准和推广标准等的变化，任何主体均不得以旧的标准为理由 要求乙方提供服务。</div>
              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>（3）如甲方不同意腾讯平台规则的调整，甲方应立即停止使用腾讯广告服务并书面 通知乙方终止本协议。甲方以任何方式继续使用腾讯广告服务的，即视为甲方认可并接受 相关腾讯平台规则。</div>
              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                （4）如腾讯平台规则调整后，甲方不再满足腾讯平台规则相关要求的，甲方应立即 书面联系乙方进行变更、修改、补充相关证明文件，或立即停止使用腾讯广告服务并书面 通知乙方终止本协议，否则乙方有权立即终止提供本服务。因此产生的全部法律后果由甲 方独立承担。
              </div>
              <div style={{ textIndent: '2em' }}>
                2.4 腾讯平台可能涉及多种平台服务（比如广点通系统、微信公众平台广告服务系 统、品牌排期广告系统等），甲方有权根据其自身需求选择腾讯广告服务的具体类型，依 照选择的服务类型注册相应的服务商账户或单独签署的广告执行单并遵守其服务规则、协 议，甲方理解并同意：
              </div>
              <div style={{ textIndent: '2.5em' }}>（1）甲方应妥善保管服务商账户及其密码。甲方有权依照腾讯平台规则授权第三方操 作其服务商帐号，但甲方应始终对其帐号下的一切行为及结果负责，承担全部责任。</div>
              <div style={{ textIndent: '2.5em' }}>
                （2）不同的腾讯广告服务可能有不同的服务商账户和子客管理规则或单独广告执行单 要求，甲方应当根据其选择的服务种类与子客在腾讯平台建立联系，或者与乙方签署明确 标明子客信息的广告执行单，确保自身获得充分的授权有权协助子客使用腾讯广告服务平 台，并督促子客遵守相应的腾讯平台规则。
              </div>
              <div style={{ textIndent: '2.5em' }}>
                （3）子客可以自行管理其腾讯平台账户，也可以依法委托第三方（包括但不限于腾讯 广告服务平台的服务商/代理商等）管理其腾讯平台账户。部分腾讯平台可能为甲方及子客 提供了关联渠道，甲方应当根据其与子客的约定，依照腾讯平台规则建立、管理、解除其 与子客的关系。
              </div>
              <div style={{ textIndent: '2.5em' }}>（4）腾讯平台上的各种工具类产品/服务，仅向甲方提供中立的技术服务，甲方应对 使用相关技术服务所导致的法律后果独立承担全部法律责任，与腾讯无关。</div>
              <div style={{ textIndent: '2em' }}>甲方应保证子客知悉并同意遵守腾讯平台规则，子客应是自愿使用腾讯广告服务的。 除另有约定外，乙方不对甲方、子客使用腾讯广告服务后的访问量、销售量、播放量等作 任何承诺。</div>
              <div style={{ textIndent: '2em' }}>甲方应依法自行与子客协商费用收取、推广投放、发票开具、费用退还等与使用腾讯 广告服务有关的全部事宜，但是，未经乙方书面同意，甲方不得以任何形式设置与乙方有 关的协议或承诺。甲方与子客之间发生的纠纷，由甲方与子客自行协商解决，与乙方无 关。</div>
              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>甲方知悉并同意，甲方子客的广告投放产生的点击及相关行为数据，甲方允许该子客 同公司主体广告账户及该子客同公司主体广告账户授权的其他服务商用于优化广告投放。</div>
              <div style={{ textIndent: '2em' }}>2.5 甲方应当遵守法律法规的规定，确保甲方自身及子客均不得实施包括但不限于以 下行为，也不得为以下行为提供便利：</div>

              <div style={{ textIndent: '2.5em' }}>（1）反对宪法所确定的基本原则的。</div>
              <div style={{ textIndent: '2.5em' }}>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的。</div>
              <div style={{ textIndent: '2.5em' }}>（3）损害国家荣誉和利益的。</div>
              <div style={{ textIndent: '2.5em' }}>（4）煽动民族仇恨、民族歧视，破坏民族团结的。</div>
              <div style={{ textIndent: '2.5em' }}>（5）破坏国家宗教政策，宣扬邪教和封建迷信的。</div>
              <div style={{ textIndent: '2.5em' }}>（6）散布谣言，扰乱社会秩序，破坏社会稳定的。</div>

              <div style={{ textIndent: '2.5em' }}>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖、骚扰、低俗或者教唆犯罪的。</div>
              <div style={{ textIndent: '2.5em' }}>（8）侮辱或者诽谤他人，侵害他人合法权益的。</div>
              <div style={{ textIndent: '2.5em' }}>（9）侵害他人知识产权、商业秘密等合法权利的。</div>
              <div style={{ textIndent: '2.5em' }}>（10）虚构事实、隐瞒真相以误导、欺骗他人的。</div>
              <div style={{ textIndent: '2.5em' }}>（11）实施博彩、赌博游戏、“私服”、“外挂”等非法互联网活动的。</div>
              <div style={{ textIndent: '2.5em' }}>（12）其他违反公序良俗或法律法规禁止的行为。</div>
              <div style={{ textIndent: '2em' }}>
                2.6 服务商在腾讯广告服务平台设置广告服务需求或与乙方签署广告执行单时，甲方 需理解因流量方业务需要可能发生媒体的改版、升级。如有此情形发生，甲乙双方友好协 商以确保改版升级不影响广告发布。若出现错播、漏播情况，或若因改版或广告资源变更
                造成甲方广告未能按期发布，乙方应向甲方补偿同等价值的广告资源用于补充发布广告。 除此之外,乙方不承担任何责任。
              </div>
              <div style={{ textIndent: '2em' }}>
                <u>2.7 腾讯广告服务平台可能为服务商、广告主提供大数据分析能力。服务商、广告主 使用的数据应为其在正常业务过程中合法收集、获取或产生的真实数据，并已采取适当安 全措施（包括但不限于采用加密手段），就该数据享有合法的所有权和处分权，有权在腾 讯广告服务平台使用该数据。</u>
              </div>
              <div style={{ textIndent: '2em' }}>
                <u>
                  甲方知悉并承诺，乙方提供的全部大数据分析服务而形成的全部数据信息或聚合报告 等全部乙方服务产生的数据的所有权、知识产权归乙方独立所有，甲方仅可基于本协议目 的而使用。对于乙方提供的大数据分析服务及结果，甲方不可以任何形式对外泄露、披露
                  或向第三方提供。同时，在不违反法律法规的前提下，甲方应及时分享本合作中关于隐私 问题的处理方式，若出现任何因本合作业务模式引起的风险，或其他引起该业务模式变化 的重大问题，甲方应及时向乙方提供相关信息。
                </u>
              </div>
              <div style={{ textIndent: '2em' }}>
                2.8 腾讯平台可能根据自身的行业经验为服务商、广告主提供内容设计、文案编写、 投放规则、选品方向等各类建议、参考及范例等（简称“参考建议”）。
                <u style={{ fontWeight: 'bold' }}>
                  参考建议为腾讯 平台为服务商、广告主提供的增值服务，且仅为参考内容，不意味着服务商、广告主可以 不加判断的任意套用，服务商、广告主应当根据自身情况评估是否适用并作必要的调整， 以确保广告合法合规，腾讯平台不对服务商、广告主使用参考建议提供任何承诺和保证，
                  因使用上述参考建议而导致的任何法律后果，由服务商、广告主自行承担。
                </u>
              </div>

              <div style={{ textIndent: '2em' }}>
                2.9 流量主可能出于自身运营安排、用户体验等考虑，对不同媒体设置不同的广告投 放规则，比如主体准入类型（比如自然人、法人等）、广告设计标准、广告审核规则、行 业准入类别、资质审核范围等，并据此对申请投放的广告进行筛选。甲方应当遵守甲方所
                选择的媒体的相应规则，并同意流量主有权对广告进行事先的筛选。
              </div>

              <div style={{ textIndent: '2em' }}>2.10 植入资源特别约定</div>

              <div style={{ textIndent: '2.5em' }}>
                （1）如媒体资源涉及腾讯公司的自制剧（包括自制影视剧及动漫等）植入资源的，乙 方负责制作相关植入资源，植入资源中将体现甲方及子客相应权益（具体权益以双方书面 确认为准）。除另有约定外，植入资源制作及发布等全部价格包含在广告执行单的总金额
                中，投放期满乙方有权将上述植入资源下线或替换。甲方知悉并确认：若卫视、网络媒体 出现播放排期调整等不可控因素，非因乙方原因或乙方无法控制的因素导致植入资源的自 制剧排播调整、无法播放等任何甲方及子客投放权益无法实现的情况，以上不视为乙方违
                约，乙方无需向甲方及子客给予任何形式的赔偿等违约责任承担。
              </div>

              <div style={{ textIndent: '2.5em' }}>（2）植入资源具体内容（包括但不限于集数、演员、时长等）甲方可提供建议，最终 以乙方确认为准。</div>

              <div style={{ textIndent: '2.5em' }}>（3）植入资源的全部知识产权归乙方所有，未经乙方书面同意，甲方及子客不可以任 何形式在其他推广、投放渠道使用该植入资源或将该植入资源授权、转让给任何第三人， 否则应就因此导致的乙方全部损失承担赔偿责任。</div>

              <div style={{ textIndent: '2.5em' }}>（4）如植入资源的广告投放合作中止或提前终止（形式包括但不限于广告撤单、因违 约被乙方解除合同），则植入资源的制作成本（包括但不限于艺人全程拍摄费用、化妆 费、差旅费等）全部由甲方承担，且甲方应就乙方全部损失承担赔偿责任。</div>
              <div style={{ fontWeight: 'bold' }}>三、甲方权利义务</div>
              <div style={{ textIndent: '2em' }}>3.1 甲方保证其是依据法律法规规定设立、经营的主体，已经取得必要经营资质，有 权利和能力签订和履行本协议，保证遵守腾讯平台规则并使用来源合法的资金支付广告费 用。</div>
              <div style={{ textIndent: '2em' }}>3.2 甲方应依法独立审核子客的资质、证明文件、广告内容、推广对象等，确保其符 合《中华人民共和国广告法》及其它相关法律法规的要求以及腾讯平台规则的要求，包括 但不限于：</div>
              <div style={{ textIndent: '2.5em' }}>（1）子客具有经营其所提供的产品和服务，并为此发布广告的资格。</div>
              <div style={{ textIndent: '2.5em' }}>（2）广告不得含有安全隐患，包括但不限于不得含有钓鱼网站、病毒、木马等恶意程 序，不得含有任何危害网络安全或损害他人权益的内容。</div>
              <div style={{ textIndent: '2.5em' }}>（3）广告中使用他人名义、形象（包括漫画形象）、标识或作品等任何权益的，或声 称与他人存在任何合作关系的，均应当事先取得权利人的同意。</div>
              <div style={{ textIndent: '2.5em' }}>
                （4）广告涉及的品牌、性能、质量、价格、允诺等全部内容应当清楚、明白且与实际 相符，包括但不限于若含有赠送、奖励（包括但不限于游戏币、虚拟物、实物、折扣优惠 等）等承诺的，应当保证承诺内容与实际情况一致，不得含有虚假的奖励、有奖销售、赠 送等内容。
              </div>
              <div style={{ textIndent: '2.5em' }}>（5）广告指向的落地页内容或推广对象，均应为合法设立且具备合法经营资质，并且 对网站等推广对象须拥有合法权利，有权对其进行宣传、使用。</div>
              <div style={{ textIndent: '2.5em' }}>
                （6）广告及推广对象不得含有任何违法违规的内容，也不得含有盗号、窃取密码、木 马、病毒等危害网络安全的恶意程序，包括但不限于推广的网站/应用/公众号等。不得推 广或销售假冒伪劣产品、从事非法经营活动、传播侵权或色情信息，推广的应用/软件或其
                他产品中不得存在扣费项目不明确、扣费提示不清晰、恶意扣费、暗设扣费程序等损害用 户权益的情况。
              </div>
              <div style={{ textIndent: '2.5em' }}>（7）法律、法规，规章制度或腾讯平台规则规定的其他情况。</div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>3.3 落地页内容应当与广告具有紧密的关联性，并且，落地页实际展示的内容与审核 时递交的内容应当保持一致，包括但不限于：</u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（1）落地页应当安全、稳定，能够正常打开浏览。</u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（2）投放期间，不得对落地页网站展示内容进行重大变更，比如将原本推广的普通 产品变更为需要具备特殊经营资质方可经营的产品等，如有任何修改需要提前通知乙方并 重新提交审核。</u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（3）不得对广告设置定向跳转，比如根据地域、时间、ip 等要素设置跳转等，使得 落地页与广告审核时的链接不一致等。</u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（4）不得通过对落地页设置恶意代码、病毒等任何方式实施违反法律、法规或本协 议约定的行为。</u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（5）违反法律、法规或腾讯平台规则的其他情形。</u>
              </div>

              <div style={{ textIndent: '2em' }}>3.4 甲方应当依法合理使用腾讯平台，不得实施任何危害腾讯平台安全或损害平台权 益的行为，包括但不限于：</div>

              <div style={{ textIndent: '2.5em' }}>（1）进行任何改变或试图改变腾讯平台服务系统配置或破坏系统安全的行为。</div>
              <div style={{ textIndent: '2.5em' }}>（2）任何破坏或试图破坏网络安全的行为，包括但不限于以病毒、木马、恶意代码、 钓鱼等方式，采取对网站、服务器进行恶意扫描、非法侵入系统、非法获取数据等。</div>
              <div style={{ textIndent: '2.5em' }}>（3）利用技术或其他手段破坏、扰乱腾讯平台的运营或妨碍他人对腾讯平台的使用， 或者制作、传播实施前述目的的方法等。</div>
              <div style={{ textIndent: '2.5em' }}>（4）仿冒或使用仿冒的腾讯平台产品（包括但不限于仿冒腾讯平台广告形式），使用 户发生误解或混淆。</div>
              <div style={{ textIndent: '2.5em' }}>（5）危害腾讯平台安全或损害平台权益的其他行为。</div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>3.5 因广告、推广对象等产生任何纠纷和争议的，应由甲方自行独立解决并承担全部 责任，包括但不限于由甲方以自己名义出面，与第三方协商、应诉或接受主管机关的审查 等，并承担所有费用、赔偿损失等。</u>
              </div>
              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>
                  甲方有承担子客责任的义务。如因甲方或子客违反本协议或腾讯平台规则给乙方、流 量主或其他任何主体造成损失的（包括但不限于因处理用户投诉、用户索赔、权利人索 赔、行政处罚等支付的费用，以及被没收的广告费等），甲方应予以赔偿并配合处理，甲
                  方不得以广告为子客投放或子客自行管理账户进行广告投放等任何理由拒绝承担本协议约 定的义务。甲方因子客违反腾讯平台规则遭受的损失，应由甲方与子客自行协商解决。
                </u>
              </div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>3.6 甲方在使用本服务过程中若需要上传并使用相关数据信息的（包括但不限于甲方 或甲方子客收集的用户信息等），甲方应承诺：</u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（1）甲方的传输行为应采取必要的安全措施（包括但不限于采用加密手段），如 传输过程中被任何第三方入侵、未经授权访问、篡改、非法获取而发生数据泄露的， 由甲方独立承担全部法律责任；同时，发生上述情况的，甲方应立即书面通知乙方；</u>
              </div>
              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（1）甲方的传输行为应采取必要的安全措施（包括但不限于采用加密手段），如 传输过程中被任何第三方入侵、未经授权访问、篡改、非法获取而发生数据泄露的， 由甲方独立承担全部法律责任；同时，发生上述情况的，甲方应立即书面通知乙方；</u>
              </div>
              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（2）甲方或甲方子客的数据信息均应为甲方或甲方子客在正常业务过程中合法收 集、获取或产生的真实数据，就该数据享有合法的处分权益，甲方在本服务中使用该 数据已获得合法授权，且授权主体已明确知晓并同意甲方用于获取本服务时使用；</u>
              </div>
              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（3）甲方使用本服务并委托乙方基于本服务处理、分析上述数据信息的行为不存 在任何违反法律法规规定、国家或行业标准（包括推荐性标准）规定的情况；</u>
              </div>
              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（4）甲方使用本服务并委托乙方基于本服务处理、分析上述数据信息的行为，不 会以任何形式侵犯任何第三人的任何形式的知识产权或其他合法权利（包括但不限于 用户的知情权、选择权、隐私权等），亦不会收到任何第三方质疑、不会与任何第三 方发生纠纷；</u>
              </div>
              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（5）甲方使用本服务并委托乙方基于本服务处理、分析上述数据信息的行为，不 会违反任何与第三方达成的任何协议，亦不存在超出与第三方达成协议约定的使用范 围。</u>
              </div>
              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>
                  若乙方认为必要时，要求甲方提供相关数据信息有权使用的证明（包括但不限于 甲方或甲方子客获得其用户授权许可的相关授权协议、隐私政策等），甲方应立即配 合乙方提供相关证明、说明文件。若甲方未提供相关证明、说明文件，或乙方判断上
                  述证明、说明文件存在瑕疵或错误的，视为甲方违反本协议约定，乙方有权随时终止 本服务并主张甲方承担违约责任。
                </u>
              </div>
              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>
                  3.7 本着创意分享、互利互助的原则，甲方同意授权乙方将甲方及其子客的广告方案 以及与乙方的商业合作案例（如营销案例、数据合作案例、品牌运营案例等），通过网站 登载、现场介绍、设计工具、产品功能等各种形式，向他人展示、介绍、评析（包括但不
                  限于以广告或合作案例为范例向他人介绍其优劣之处等），或供他人参考、学习、评选 等，并在上述活动中使用甲方及其子客的名称和商业标识。
                </u>
              </div>

              <div style={{ fontWeight: 'bold' }}>四、乙方权利义务</div>
              <div style={{ textIndent: '2em' }}>4.1 乙方提供与腾讯广告服务有关的技术支持或资料说明,并负责腾讯平台系统的运 营、维护。为了完善腾讯广告服务，乙方及其关联公司、乙方合作伙伴有权不断调整腾讯 平台及其具体服务，腾讯平台及其具体服务名称、功能、域名的调整，不影响本协议的效 力。</div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>乙方有权根据单方运营安排随时调整或终止部分或全部的服务，包括但不限于停止特 定服务、对某项服务进行升级、调整某项服务的功能或整合某些服务等。甲方有权根据自 身需求决定是否继续使用相关服务。</u>
              </div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>
                  4.2 乙方有权对甲方和子客的证明文件及广告进行审核并根据腾讯平台规则决定是否 允许投放广告，该审核仅为形式审核，乙方不对上述证明文件、广告予以任何保证和承 诺，也不代表乙方有义务对广告的真实性、合法性进行任何确认或担保，并且，并不因为
                  乙方的审核，而减轻甲方对子客经营资质、广告等的真实性、合法性的保证责任，由此产 生的一切责任和后果仍由甲方单独承担。
                </u>
              </div>

              <div style={{ textIndent: '2em' }}>
                4.3 为依法合理保护各方的利益，乙方有权制定专门的侵权投诉处理流程，甲方及子 客应当予以遵守。
                <u style={{ fontWeight: 'bold' }}>
                  如甲方或子客受到主管部门调查或被第三方投诉，或甲方、子客投诉第 三方，乙方有权根据自行判断将争议中相关方的主体资料、联系方式、投诉相关内容等必 要信息（包括但不限于名称、电话、证照等）提供给主管部门或相关方，以便及时解决投 诉纠纷，保护各方合法权益，甲方及子客应当予以配合。
                </u>
              </div>

              <div style={{ textIndent: '2em' }}>
                若甲方或子客受到主管部门调查或第三方投诉，甲方应在 3 个自然日内妥善处理，否 则，乙方有权在按照本协议约定采取相应措施的同时，为维护投诉方合法权益，自主决定 先行垫付费用用于处理纠纷及赔偿损失，乙方有权在甲方服务商账户或违约子客子账户内 直接扣除相应费用，或另行向甲方追偿。
              </div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>
                  4.4 如广告受到主管机关调查或被第三方（包括但不限于用户、权利人等，下同）投 诉，或者甲方、子客存在违反法律法规的情形，乙方有权根据一般人的认识自行独立判 断，以认定甲方是否存在违法违规的情况。若乙方经过判断认为甲方、子客存在违法违
                  规，或违反本协议约定（包括但不限于违反本协议相关禁止性规定、未履行相关义务、逾 期付款等）的，乙方有权随时单方对甲方采取以下一项或多项措施：
                </u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（1）停止涉嫌违规广告的投放，无论该广告是否已经上线。</u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（2）要求甲方或违规子客对广告进行修改直至符合相关规定或更正违约行为。</u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（3）对甲方、违约子客提交的全部广告予以下线，永久或暂时封停服务商账户。</u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（4）限制甲方、违约子客使用腾讯广告服务，暂停甲方提交的全部内容的审核工 作。</u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>
                  （5）对甲方罚款、扣除保证金，或扣除甲方服务商账户或违约子客子账户剩余款 项，或，要求甲方在指定期限内支付等额现金。相关费用可用于赔偿用户损失和支付合理 费用等，包括但不限于赔偿乙方、流量主或其他任何主体等因甲方或子客行为导致的损失
                  （如行政罚款、权利人索赔、用户赔偿，以及被没收的广告费等）。
                </u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（6）暂停或终止返货/返点等优惠的发放（无论是否已经产生）以及收回已经发放的 返货/返点等优惠的等处罚，相关费用可直接从甲方服务商账户中扣除（如果返货已经消 耗的，则乙方有权按照等值现金在甲方服务商账户内直接抵扣），或要求甲方在指定期限 内支付等额现金。</u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（7）扣除甲方服务商账户或违约子客子账户全部剩余款项作为违约金，不予退还 （剩余款项不足以赔偿乙方损失的，甲方应予补足）。</u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（8）封停账户，终止本协议，要求甲方承担违约责任等，同时，可以禁止甲方再次 使用腾讯平台。</u>
              </div>

              <div style={{ textIndent: '2.5em', fontWeight: 'bold' }}>
                <u>（9）其他依据腾讯平台规则采取的措施。</u>
              </div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>乙方依据本协议约定对甲方及其子客采取措施所引起的纠纷、责任等一概由甲方自行 负责，若因此给甲方、子客或其他主体造成损失（包括但不限于相关数据清空、投放计划 未能完成、剩余预付款作为违约金而归乙方所有等）的，甲方应自行承担；造成乙方或他 人损失的，甲方应独立承担赔偿责任。</u>
              </div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>
                  4.5 为向服务商、广告主提供更优质服务，以及不断提高腾讯广告服务水平，乙方有 权对服务商、广告主使用腾讯广告服务过程中产生的信息（包括但不限于点击率等）进行 整理、分析，并将前述整理、分析结果用于腾讯广告服务，包括但不限于以供后续向服务
                  商、广告主提供持续的、更优质的服务、依据信息进行行业分析和用户调研或向相关用户 提供更加合适的广告等。
                </u>
              </div>

              <div style={{ textIndent: '2em' }}>4.6 为保护服务商和广告主腾讯平台账户的安全，乙方有权对超过一定期限未有操作 的账户进行暂时冻结，如果甲方需要重新启用被暂时冻结的账户，甲方需要再次激活该账 户。</div>

              <div style={{ textIndent: '2em' }}>4.7 乙方有权根据业务经营需求，将本协议中的全部或部分权利与义务转让给乙方的 关联公司，但须提前 30 个工作日书面通知甲方。</div>

              <div style={{ textIndent: '2em' }}>4.8 乙方有权以短信、即时通讯信息（如 QQ、微信等）、电子邮件、系统公告、站内 消息等方式中的一种或多种，向甲方发送与腾讯广告服务有关的信息，包括但不限于营销 活动、折扣优惠、新增服务类型、广告等。</div>

              <div style={{ textIndent: '2em' }}>4.9 乙方因本协议项下合作所承担的赔偿责任总额不超过违约服务对应的当次广告费 的总额，并且，对于与本协议项下合作有关或由其引起的任何损失，均不承担任何赔偿责 任。</div>

              <div style={{ fontWeight: 'bold' }}>五、费用结算</div>

              <div style={{ textIndent: '2em' }}>5.1 广告费</div>

              <div style={{ textIndent: '2.5em' }}>（1）广告费以人民币计算。腾讯广告服务采用预付费方式，双方另有约定除外。甲方 需保持服务商账户及子客子账户内余额充足并及时续费，或提前支付广告执行单约定广告 费，否则，会影响广告的投放。</div>

              <div style={{ textIndent: '2.5em' }}>（2）广告的投放次数、点击次数、曝光次数等数据，以及服务商与子客的绑定时间、 解绑时间、绑定期间的消耗数据等与使用腾讯广告服务有关的数据均以乙方后台统计数据 为准。</div>

              <div style={{ textIndent: '2.5em' }}>
                （3）如涉及视频 CPM 类型的广告投放，其效果数据结果以乙方的效果数据为准，或以 甲方确认的且通过乙方技术认证的独立第三方广告效果数据监测公司的效果数据为准。如 以上述第三方广告效果数据监测公司的效果数据为准的，甲方应于每次广告投放后一个工
                作日内向乙方提供第三方效果监测数据，同时乙方有权在广告投放期间随时要求甲方提供 最新的第三方效果监测数据，甲方在收到乙方要求后必须在一个工作日内向乙方提供最新 的第三方效果监测数据，如甲方未能按约定时间向乙方提供第三方效果监测数据，则本条 款所述 CPM
                类型广告投放的效果数据仍以乙方提供的数据信息为准。
              </div>

              <div style={{ textIndent: '2em' }}>5.2 发票</div>

              <div style={{ textIndent: '2.5em' }}>（1）乙方在收到甲方付款后，根据甲方的申请为甲方开具发票；发票面额为甲方向乙 方支付的现金总额。</div>

              <div style={{ textIndent: '2.5em' }}>（2）发票不可重复开具，因甲方递交材料错误造成的发票抬头、邮寄地址等信息错 误，由甲方自行承担全部后果。</div>

              <div style={{ textIndent: '2.5em' }}>
                （3）甲方申请被审核通过后，乙方将在审核通过后的次月完成发票开具；相关发票一 经发送至甲方所填写的通讯地址，即视为乙方已经完成了发票开具义务。如非乙方原因造成发票延迟发送或未发送至甲方所填地址，也视为乙方完成发票开具义务。由此，可能为
                甲方带来的发票风险，乙方将在甲方的要求下，给予协助。
              </div>

              <div style={{ textIndent: '2.5em' }}>（4）乙方仅向甲方开具发票，乙方不向甲方子客或任何其他第三方开具发票。甲方应 当依照其与子客的约定，自行为子客子账户充值或向乙方支付广告执行单款项，并向子客 开具票据。</div>

              <div style={{ textIndent: '2em' }}>5.3 退款</div>
              <div style={{ textIndent: '2em' }}>若甲方服务商账户内有现金剩余款项的，甲方可申请对服务商账户内现金部分剩余款 项进行退款，但需同时满足下列条件：</div>

              <div style={{ textIndent: '2.5em' }}>（1）甲方已填写相关申请文件，并应在发票开具日期所在的当月将发票退回到乙方， 且甲方未对发票进行税务认证。</div>
              <div style={{ textIndent: '2.5em' }}>（2）甲方没有任何未处理完毕的事宜，包括但不限于违规处罚、违约赔偿或投诉纠纷。</div>
              <div style={{ textIndent: '2.5em' }}>（3）服务商账户中的非现金部分（包括但不限于赠送的虚拟金、返货、信用等）不可退款。</div>
              <div style={{ textIndent: '2.5em' }}>（4）乙方收到甲方退回的完整、有效发票后在次月内，将按照甲方实际消费数额重新 开具发票，并进行现金部分剩余款项的退款。</div>
              <div style={{ textIndent: '2.5em' }}>
                （5）甲方应自行妥善保管发票。甲方理解并同意，若无法退回乙方已经开具的发票 （包括但不限于以下情形：甲方已经对发票进行税务认证或者退回发票的时间已超过开票 日期所在当月），则甲方需向乙方提供开具红字发票的必要资料，如填开并上传《开具红
                字增值税专用发票信息表》等，才可申请退款；若无法退回乙方已经开具的发票，或无法 向乙方提供必要资料开具红字发票的，则无法办理退款，后果由甲方自行承担。
              </div>
              <div style={{ textIndent: '2.5em' }}>（6）对于乙方尚未开具发票或已开具发票但尚未交付甲方的退款，无需甲方提供发票 相关资料。</div>

              <div style={{ fontWeight: 'bold' }}>六、返货/返点政策</div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>6.1 乙方根据业务发展的需要，独立自主制定或调整各类返货/返点政策（包括但不 限于返货/返点政策的种类、计算、适用、发放、罚没规则等），具体返货/返点政策的制 定及调整以乙方最近一次的通知内容为准，且各方据此执行。返货/返点政策一经通知即 对甲方产生约束力，甲方应当予以遵守。</u>
              </div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>
                  6.2 若甲方逾期付款或有其他任何违反本协议约定的行为的，乙方有权暂停或终止返 货/返点政策的执行或依照返货/返点政策采取处罚措施；情节严重的，乙方有权收回已经 发放的返货/返点（如果返货/返点已经消耗的，则乙方有权按照等值现金在甲方服务商账
                  户中直接抵扣，或要求甲方在指定期限内支付等额现金）。
                </u>
              </div>

              <div style={{ fontWeight: 'bold' }}>七、保密</div>
              <div style={{ textIndent: '2em' }}>
                7.1 甲乙双方为了本协议之目的，已经或将会提供或披露某些保密信息。保密信息指 由协议一方持有的与其业务、经营、技术及权利等事项相关的，非公开的信息（包括但不 限于用户投诉处理方案、违规处理方案、诉讼情况等）、资讯、数据、资料。其中，披露 信息的一方为“披露方”，而接受信息的一方为“接收方”。
              </div>

              <div style={{ textIndent: '2em' }}>7.2 除本协议另有规定的情况外，未经披露方事先书面同意，接收方不可为其自身业 务目的或其他目的使用或向任何第三方披露任何披露方的保密信息。双方应保证本方雇员 履行上述义务。</div>

              <div style={{ textIndent: '2em' }}>7.3 保密信息不包含下列任何信息：</div>

              <div style={{ textIndent: '2.5em' }}>（1）在披露时已经被公众所知的信息；</div>
              <div style={{ textIndent: '2.5em' }}>（2）在披露后，非因可归责于接收方的原因被公众所知的信息；</div>
              <div style={{ textIndent: '2.5em' }}>（3）接收方不承担保密义务而从拥有正当权限的第三方合法获得的信息；</div>
              <div style={{ textIndent: '2.5em' }}>（4）由接收方在没有参考披露方保密信息的情况下独立开发的信息；</div>
              <div style={{ textIndent: '2.5em' }}>（5）由披露方以书面形式同意接收方可以进一步披露的信息，但仅限于披露方书面同 意中规定的范畴。</div>

              <div style={{ textIndent: '2em' }}>7.4 接收方不会因为在遵守本条的规定下进行的披露而承担任何法律责任：</div>

              <div style={{ textIndent: '2.5em' }}>（1）一方为实现本协议之目的，需向其员工、关联方及其员工或专业顾问等进行的信 息披露。</div>

              <div style={{ textIndent: '2.5em' }}>（2）因甲方及其子客使用的服务的产品规则（包括但不限于在线支付等功能）或该服 务本身依据法律法规等的要求，需要向服务提供方提供相关主体必要信息的。</div>

              <div style={{ textIndent: '2.5em' }}>
                （3）根据法律法规、司法机关、行政机关或证券交易所的规定、指令或要求，接收方 必须披露任何保密信息的，但是，接收方应在可行并法律允许的条件下及时向披露方发出 书面通知，并且应尽合理努力协助披露方寻求救济措施。如披露方未能获取救济措施，则
                接收方应尽合理努力仅提供被要求披露的那一部分保密信息。
              </div>

              <div style={{ textIndent: '2em' }}>7.5 尽管有前述规定，甲方认可乙方属于一个由多个法律实体组成的集团的一部分， 为了实现本协议项下合作目的，乙方可能需要向其关联机构（定义见下文）提供甲方的保 密信息，因此，甲方同意：</div>

              <div style={{ textIndent: '2.5em' }}>（1）乙方可在其关联机构为了实现本协议目的而有必要知悉的范围内向其关联机构 披露甲方的保密信息。</div>

              <div style={{ textIndent: '2.5em' }}>（2）由或向乙方某关联机构作出的披露应被视为由或向乙方本身作出的披露。</div>

              <div style={{ textIndent: '2.5em' }}>（3）乙方可在其分包商、合作伙伴为了实现本协议目的而有必要知悉的范围内，并 在该等分包商、合作伙伴接受了严格程度至少不低于本协议的保密义务的前提下向该等分 包商、合作伙伴披露甲方的保密信息。</div>

              <div style={{ textIndent: '2em' }}>
                在本协议中，“关联机构”指任何直接或间接地控制乙方、被乙方控制或与乙方共 同受控于同一控制人的任何实体。“控制”，包括“被控制”、“共同受控”等相关词 语，指当前或此后、直接或间接,通过表决权、合同安排或者其他方式，拥有决定受控实
                体管理层和政策方向的权力；而且，在不影响前述意思的前提下，只要任何实体持有或 控制了任何受控实体已发行在外的有表决权之证券或者其他形式之所有者权益至少百分 之五十（50%）的表决权和/或代理表决权，则会被视为对该受控实体拥有前述控制权 力。
              </div>

              <div style={{ textIndent: '2em' }}>7.6 保密义务不因本协议的解除、终止或撤销而失效。</div>

              <div style={{ fontWeight: 'bold' }}>八、不可抗力及免责</div>

              <div style={{ textIndent: '2em' }}>8.1 因受不可抗力影响而不能履行或不能完全履行本协议的一方无需承担违约责任。</div>

              <div style={{ textIndent: '2em' }}>但是，遇有不可抗力事件的一方，应立即将事件情况书面通知对方，并应于 5 个工作 日内出示有效证明。双方按照事件对协议的履行的影响程度，再行协商决定是否继续履行 本协议或终止协议。</div>

              <div style={{ textIndent: '2em' }}>8.2 鉴于互联网之特殊性质，乙方的免责事由亦包括但不限于下列任何影响腾讯平台 正常运营之情形：</div>

              <div style={{ textIndent: '2.5em' }}>（1）黑客攻击、计算机病毒侵入或发作。</div>

              <div style={{ textIndent: '2.5em' }}>（2）计算机系统遭到破坏、瘫痪或无法正常使用导致乙方未能依约履行协议。</div>

              <div style={{ textIndent: '2.5em' }}>（3）基础运营商或主管部门故障、调整导致之影响。</div>

              <div style={{ textIndent: '2.5em' }}>（4）因政府管制而造成的暂时性关闭、服务调整等。</div>

              <div style={{ textIndent: '2.5em' }}>（5）国家法律法规或者政策的颁布、调整、变更等导致的。</div>

              <div style={{ textIndent: '2.5em' }}>（6）由于甲方或子客原因（包括但不限于操作失误、系统故障等）导致的。</div>

              <div style={{ textIndent: '2.5em' }}>（7）其它非乙方过错造成的原因等。</div>

              <div style={{ fontWeight: 'bold' }}>九、协议终止</div>

              <div style={{ textIndent: '2em' }}>9.1 出现以下任一情形的，本协议终止：</div>

              <div style={{ textIndent: '2.5em' }}>（1）双方协商一致终止。</div>

              <div style={{ textIndent: '2.5em' }}>（2）任何一方注销、破产、解散等。</div>

              <div style={{ textIndent: '2.5em' }}>（3）服务期限届满且双方未续约或任意一方依约终止协议。</div>

              <div style={{ textIndent: '2.5em' }}>（4）因不可抗力影响，使协议无法履行或者已无履行的必要。</div>

              <div style={{ textIndent: '2.5em' }}>（5）任何一方违反本协议导致协议终止的其他情形。</div>

              <div style={{ textIndent: '2em' }}>9.2 协议终止后，甲方应立刻停止以任何方式使用乙方品牌和标识，不得再以腾讯广 告服务商等名义开展业务。</div>

              <div style={{ textIndent: '2em' }}>9.3 无论本协议因何原因终止或解除，甲方均应妥善保障子客合法权益，否则，乙方 有权视情形通过其他方式继续向子客提供服务，其他方式包括但不限于乙方直接管理、重 新为该子客指定服务商等。</div>

              <div style={{ textIndent: '2em' }}>9.4 本协议的提前终止不影响双方于本协议提前终止日之前，根据本协议已产生的权 利和义务。</div>

              <div style={{ fontWeight: 'bold' }}>十、法律适用及争议解决</div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>10.1 本协议签订地为中华人民共和国广东省深圳市南山区。</u>
              </div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>10.2 本协议的订立、履行、变更、终止、解除等一切事项均适用中华人民共和国大 陆地区法律，不包括冲突法。</div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>10.3 若双方因本协议发生任何争议，首先应友好协商解决；协商不成的，应将争议 提交协议签订地有管辖权的人民法院解决。</u>
              </div>

              <div style={{ fontWeight: 'bold' }}>十一、附则</div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>
                <u>11.1 本协议内容包括协议正文及所有与腾讯平台相关的已经发布的或将来可能发布 的各类腾讯平台规则。上述内容为本协议不可分割的一部分，与本协议正文具有同等法律 效力。甲方在使用腾讯平台服务时，应予遵守。</u>
              </div>

              <div style={{ textIndent: '2em', fontWeight: 'bold' }}>11.2 本协议以数据电文形式签订，自甲方在腾讯平台点击“同意”或“下一步”（具 体措辞以服务开通时显示的为准）后生效。</div>

              <div style={{ textIndent: '2em' }}>双方合作期限自甲方确认接受本协议当天起至点击同意当年最后一个自然日止，比如 甲方在 2019 年 6 月 1 日点击同意，则合作期限至 2019 年 12 月 31 日止。期限届满前任何 一方均未书面提出到期不续约的要求的，双方合作期限将自动顺延 1 年，顺延次数不限。</div>
              <div style={{ textIndent: '2em' }}>任何一方均有权提前 30 个自然日书面通知对方，终止本协议。双方应按照本协议约 定结清费用，并妥善处理用户投诉、违约金、赔偿款以及退款等相关事宜（如有）。</div>
              <div style={{ textIndent: '2em' }}>11.3 若本协议有效期限与甲方使用腾讯广告服务的期限不一致的，则本协议合作期限 自动涵盖甲方使用腾讯广告服务整个期间。除非双方另有约定或重新签订同类协议，本协 议在甲方使用腾讯广告服务期间持续有效。</div>
              <div style={{ textIndent: '2em' }}>11.4 如本协议的任何条款被视作无效或无法执行，则除上述条款可被分离外，其余部分 条款则仍具有法律效力。</div>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}
export default Agreement;
